module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"subnav-label visible-xs-block\">Dashboard</div> <nav class=\"subnav-links\"> <ul class=\"nav\"> ")
    ;  _.each(locals.filteredNavItems, function(item) { 
    ; __append(" ")
    ;  if(!item.get('route')) { 
    ; __append(" <li> <a class=\"no-hover\">")
    ; __append(escapeFn( item.get('readable') ))
    ; __append("</a> </li> ")
    ;  } else { 
    ; __append(" <li data-page=\"")
    ; __append(escapeFn( item.get('route') ))
    ; __append("\" class=\"")
    ; __append(escapeFn( item.get('isSubItem') ? 'sub-item': '' ))
    ; __append("\"> <a href=\"/account/")
    ; __append(escapeFn( item.get('route') ))
    ; __append("\">")
    ; __append(escapeFn( item.get('readable') ))
    ; __append("</a> </li> ")
    ;  } 
    ; __append(" ")
    ;  }); 
    ; __append(" </ul> </nav> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/account_nav.ejs
// module id = 821
// module chunks = 1